import { Checkbox, Col, DatePicker, Form, FormInstance, Radio } from 'antd'

import { requiredRules } from 'src/app-constants'
import { dayMonthYearFormatWithDot, disabledFutureDate } from 'src/libs'
import { useLocales } from 'src/locales'

type Props = {
  form: FormInstance
}

export const SkinAndMucousSymptomsCard = ({ form }: Props) => {
  const { t } = useLocales()

  const hasSkinAndMucousSymptoms =
    Form.useWatch(['form', 'symptoms', 'skinAndMucous', 'status'], form) ===
    'yes'

  const hasRashes = Form.useWatch(
    ['form', 'symptoms', 'skinAndMucous', 'rashes', 'isSelected'],
    form
  )

  const hasIcter = Form.useWatch(
    ['form', 'symptoms', 'skinAndMucous', 'icter', 'isSelected'],
    form
  )

  const hasInjuries = Form.useWatch(
    ['form', 'symptoms', 'skinAndMucous', 'injuries', 'isSelected'],
    form
  )

  return (
    <>
      <Col span={24}>
        <Form.Item
          name={['form', 'symptoms', 'skinAndMucous', 'status']}
          rules={requiredRules}
          label={`2. ${t('epidemiology.skin_and_mucous')}`}
        >
          <Radio.Group>
            <Radio value="dontKnow">{t('epidemiology.unknown')}</Radio>
            <Radio value="no">{t('common.no')}</Radio>
            <Radio value="yes">{t('common.yes')}</Radio>
          </Radio.Group>
        </Form.Item>
      </Col>

      {hasSkinAndMucousSymptoms && (
        <>
          <Col span={8}>
            <Form.Item
              name={[
                'form',
                'symptoms',
                'skinAndMucous',
                'rashes',
                'isSelected'
              ]}
              valuePropName="checked"
            >
              <Checkbox>1. Erupții cutanate</Checkbox>
            </Form.Item>
          </Col>

          {hasRashes && (
            <>
              <Col span={8}>
                <Form.Item
                  name={[
                    'form',
                    'symptoms',
                    'skinAndMucous',
                    'rashes',
                    'appearanceDate',
                    'value'
                  ]}
                  label="Data apariției"
                >
                  <DatePicker
                    className="full-width"
                    format={dayMonthYearFormatWithDot}
                    disabledDate={disabledFutureDate}
                  />
                </Form.Item>
              </Col>

              <Col span={8}>
                <Form.Item
                  name={[
                    'form',
                    'symptoms',
                    'skinAndMucous',
                    'rashes',
                    'maculoPapular',
                    'isSelected'
                  ]}
                  valuePropName="checked"
                >
                  <Checkbox>1.1 Maculo-papulare</Checkbox>
                </Form.Item>
              </Col>

              <Col span={8}>
                <Form.Item
                  name={[
                    'form',
                    'symptoms',
                    'skinAndMucous',
                    'rashes',
                    'microPapular',
                    'isSelected'
                  ]}
                  valuePropName="checked"
                >
                  <Checkbox>1.2 Micro-papulare</Checkbox>
                </Form.Item>
              </Col>

              <Col span={8}>
                <Form.Item
                  name={[
                    'form',
                    'symptoms',
                    'skinAndMucous',
                    'rashes',
                    'vesicles',
                    'isSelected'
                  ]}
                  valuePropName="checked"
                >
                  <Checkbox>1.3 Vezicule</Checkbox>
                </Form.Item>
              </Col>

              <Col span={8}>
                <Form.Item
                  name={[
                    'form',
                    'symptoms',
                    'skinAndMucous',
                    'rashes',
                    'hemoragic',
                    'isSelected'
                  ]}
                  valuePropName="checked"
                >
                  <Checkbox>1.4 Hemoragice</Checkbox>
                </Form.Item>
              </Col>

              <Col span={8}>
                <Form.Item
                  name={[
                    'form',
                    'symptoms',
                    'skinAndMucous',
                    'rashes',
                    'petehii',
                    'isSelected'
                  ]}
                  valuePropName="checked"
                >
                  <Checkbox>1.5 Peteșii</Checkbox>
                </Form.Item>
              </Col>

              <Col span={8}>
                <Form.Item
                  name={[
                    'form',
                    'symptoms',
                    'skinAndMucous',
                    'rashes',
                    'eritem',
                    'isSelected'
                  ]}
                  valuePropName="checked"
                >
                  <Checkbox>1.6 Eritem</Checkbox>
                </Form.Item>
              </Col>

              <Col span={8}>
                <Form.Item
                  name={[
                    'form',
                    'symptoms',
                    'skinAndMucous',
                    'rashes',
                    'pustule',
                    'isSelected'
                  ]}
                  valuePropName="checked"
                >
                  <Checkbox>1.7 Pustule</Checkbox>
                </Form.Item>
              </Col>
            </>
          )}

          <Col span={8}>
            <Form.Item
              name={[
                'form',
                'symptoms',
                'skinAndMucous',
                'carbuncul',
                'isSelected'
              ]}
              valuePropName="checked"
            >
              <Checkbox>2. Carbuncul</Checkbox>
            </Form.Item>
          </Col>

          <Col span={8}>
            <Form.Item
              name={[
                'form',
                'symptoms',
                'skinAndMucous',
                'sancru',
                'isSelected'
              ]}
              valuePropName="checked"
            >
              <Checkbox>3. Șancru</Checkbox>
            </Form.Item>
          </Col>

          <Col span={8}>
            <Form.Item
              name={[
                'form',
                'symptoms',
                'skinAndMucous',
                'icter',
                'isSelected'
              ]}
              valuePropName="checked"
            >
              <Checkbox>4. Icter</Checkbox>
            </Form.Item>
          </Col>

          {hasIcter && (
            <Col span={8}>
              <Form.Item
                name={[
                  'form',
                  'symptoms',
                  'skinAndMucous',
                  'icter',
                  'appearanceDate',
                  'value'
                ]}
                label="Data apariției"
              >
                <DatePicker
                  className="full-width"
                  format={dayMonthYearFormatWithDot}
                  disabledDate={disabledFutureDate}
                />
              </Form.Item>
            </Col>
          )}

          <Col span={8}>
            <Form.Item
              name={[
                'form',
                'symptoms',
                'skinAndMucous',
                'injuries',
                'isSelected'
              ]}
              valuePropName="checked"
            >
              <Checkbox>5. Leziuni</Checkbox>
            </Form.Item>
          </Col>

          {hasInjuries && (
            <>
              <Col span={8}>
                <Form.Item
                  name={[
                    'form',
                    'symptoms',
                    'skinAndMucous',
                    'injuries',
                    'animalBite',
                    'isSelected'
                  ]}
                  valuePropName="checked"
                >
                  <Checkbox>5.1 Mușcătură de animal</Checkbox>
                </Form.Item>
              </Col>

              <Col span={8}>
                <Form.Item
                  name={[
                    'form',
                    'symptoms',
                    'skinAndMucous',
                    'injuries',
                    'arthropodBite',
                    'isSelected'
                  ]}
                  valuePropName="checked"
                >
                  <Checkbox>5.2 Înțepătură de artropod</Checkbox>
                </Form.Item>
              </Col>

              <Col span={8}>
                <Form.Item
                  name={[
                    'form',
                    'symptoms',
                    'skinAndMucous',
                    'injuries',
                    'appearanceDate',
                    'value'
                  ]}
                  label="Data apariției"
                >
                  <DatePicker
                    className="full-width"
                    format={dayMonthYearFormatWithDot}
                    disabledDate={disabledFutureDate}
                  />
                </Form.Item>
              </Col>
            </>
          )}
        </>
      )}
    </>
  )
}
